// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2gtv0","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__24Igz"};